import React, { Suspense } from 'react';
import Loading from 'shared/ui/Loading';
import SnapsList from 'features/stats/components/snaps/SnapsList';

const Snaps = () => {
  return (
    <>
      <Suspense fallback={<Loading/>}>
        <div className='bg-gray-100 py-4 px-6 flex justify-between items-center relative'>
          <div className='flex items-center relative'>
            <h1 className='text-2xl font-bold'>Снапы</h1>
          </div>
        </div>
        
        <SnapsList/>
      </Suspense>
    </>
  );
};

export default Snaps;
